const sellSteps = {
  step_1: 0,
  doNotKnowPrice: {
    step_1: 1,
    step_2: 2,
    step_3: 3,
    sell: {
      step_1: 4,
      step_2: 5,
      step_3: 6,
      step_4: 7,
      step_5: 8,
      step_6: 9,
    },
    swap: {
      step_1: 10,
      step_2: 11,
      step_3: 12,
      step_4: 13,
      step_5: 14,
      step_6: 15,
    },
  },
  knowPrice: {
    step_1: 16,
    step_2: 17,
    step_3: 18,
    step_4: 19,
    step_5: 20,
    step_6: 21,
    step_7: 22,
    step_8: 23,
    step_9: 24,
    step_10: 25,
  },
};

export default sellSteps;
